import { TextInput, Icon } from '@octano/global-ui';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { SectionTitle } from '../../../components/text';

export interface FormViewProps {
  date: string;
  createdAt: string | null;
  graduationGrade: string;
  degreeGrade?: string;
  distinctionRank: string;
  registerCode?: string;
  certificateNumber?: string;
  registryBook?: string;
  exemptionCertificateCode?: string;
}

const dictPrefix = 'studentsDegreeStudent';

export default function FormView(props: FormViewProps) {
  const { t } = useTranslation();

  const texts = useMemo(
    () => ({
      distinctionRankLabel: t(`${dictPrefix}.form.distinctionRank`),
      graduationGradeLabel: t(`${dictPrefix}.form.graduationGrade`),
      degreeGradeLabel: t(`${dictPrefix}.form.degreeGrade`),
      dateLabel: t(`${dictPrefix}.form.date`),
      registerCodeLabel: t(`${dictPrefix}.form.registerCode`),
      certificateNumberLabel: t(`${dictPrefix}.form.certificateNumber`),
      registryBookLabel: t(`${dictPrefix}.form.registryBook`),
      createdAtLabel: t(`${dictPrefix}.form.createdAt`, {
        date: props.createdAt
          ? dayjs(props.createdAt).format('DD/MM/YYYY')
          : 'N/A',
      }),
      exemptionCertificateCodeLabel: t(
        `${dictPrefix}.form.exemptionCertificateCode`,
      ),
    }),
    [t, props.createdAt],
  );

  return (
    <>
      <div className="mt-4 mb-2">
        <SectionTitle text={t(`${dictPrefix}.form.sectionTitle`)} />
        {!!props.createdAt && (
          <div className="d-flex justify-content-start align-items-center mb-4">
            <Icon name="success" color="success" />
            <span className="text-dark ml-2">{texts.createdAtLabel}</span>
          </div>
        )}
      </div>
      <Row>
        <Col className="pb-3" xs={12} xl={6}>
          <TextInput
            name="distinctionRank"
            label={texts.distinctionRankLabel}
            value={props.distinctionRank}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="graduationGrade"
            label={texts.graduationGradeLabel}
            value={props.graduationGrade}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="degreeGrade"
            label={texts.degreeGradeLabel}
            value={props.degreeGrade}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="date"
            label={texts.dateLabel}
            value={dayjs(props.date).format('DD/MM/YYYY')}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="registerCode"
            label={texts.registerCodeLabel}
            value={props.registerCode}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="certificateNumber"
            label={texts.certificateNumberLabel}
            value={props.certificateNumber}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="registryBook"
            label={texts.registryBookLabel}
            value={props.registryBook}
            readOnly
          />
        </Col>
        <Col className="pb-3" xs={12} xl={3}>
          <TextInput
            name="exemptionCertificateCode"
            label={texts.exemptionCertificateCodeLabel}
            value={props.exemptionCertificateCode}
            readOnly
          />
        </Col>
      </Row>
    </>
  );
}
